export default __webpack_public_path__ + "static/media/completeSandwich.8a6bb8dc.png";